import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { Spin } from 'antd';
//import { Line } from 'react-chartjs-2';
import { loadTopTrendingTags } from '../../redux/actions/widgets';
import styles from './top-trending-tags.module.sass';
import { STATUS } from '../../redux/constants';
import { selectTrendingTags } from '../../redux/selectors/widgets';

export const TopTrendingTags = (props) => {
  const { status, data } = props;
  useEffect(() => {
    props.loadTopTrendingTags();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const isLoading = status === STATUS.LOADING;

  const options = {
    maintainAspectRatio: false,
  };

  return (
    <div className={styles.container}>
      {isLoading && <Spin />}
      {/* {!isLoading && data && <Line data={data} options={options} />} */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: selectTrendingTags(state),
  status: state.widgets.topTrendingTagsStatus,
});

const mapDispatchToProps = {
  loadTopTrendingTags,
};

TopTrendingTags.propTypes = {
  loadTopTrendingTags: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

TopTrendingTags.defaultProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TopTrendingTags);
